import $ from 'jquery';

if (!window.$) {
    window.$ = $;
}
if (!window.jQuery) {
    window.jQuery = $;
}

let livePromise;
let playbackPromise;
let aliplayerPromise;

/**
 * 初始化直播SDK
 */
export function initLiveSDKLoader() {
    const DWLive = window.DWLive;
    if (DWLive) {
        return Promise.resolve(DWLive);
    }
    if (!livePromise) {
        const script = document.createElement('script');
        script.id = 'live-sdk';
        script.type = 'text/javascript';
        script.src = '//view.csslcloud.net/js/sdk/3.5.1/liveSDK.js';
        document.body.appendChild(script);
        livePromise = new Promise((resolve) => {
            script.onload = function () {
                const DWLive = window.DWLive;
                resolve(DWLive);
            };
        });
    }
    return livePromise;
}

/**
 * 初始化回放SDK
 */
export function initPlaybackSDKLoader() {
    const DW = $.DW;
    if (DW) {
        return Promise.resolve(DW);
    }
    if (!playbackPromise) {
        const script = document.createElement('script');
        script.id = 'playback-sdk';
        script.type = 'text/javascript';
        script.src = '//view.csslcloud.net/js/sdk/3.5.1/playbackSDK.js';
        document.body.appendChild(script);
        playbackPromise = new Promise((resolve) => {
            script.onload = function () {
                const DW = $.DW;
                resolve(DW);
            };
        });
    }
    return playbackPromise;
}

/**
 * 初始化阿里播放器SDK
 */
export function initAliPlayerSDKLoader() {
    const Aliplayer = window.Aliplayer;
    if (Aliplayer) {
        return Promise.resolve(Aliplayer);
    }
    if (!aliplayerPromise) {
        // if (process.env.NODE_ENV === 'production') {
        //     initAliPrisPlayerSDKLoader();
        // }
        const script = document.createElement('script');
        script.id = 'ali-palyer-sdk';
        script.type = 'text/javascript';
        script.src = '//g.alicdn.com/de/prismplayer/2.8.2/aliplayer-h5-min.js';
        document.body.appendChild(script);
        aliplayerPromise = new Promise((resolve) => {
            script.onload = function () {
                const Aliplayer = window.Aliplayer;
                resolve(Aliplayer);
            };
        });
    }
    return aliplayerPromise;
}
/**
 * 初始化加密阿里播放器SDK
 */
export function initAliPrisPlayerSDKLoader() {
    const script = document.createElement('script');
    script.id = 'ali-pris-palyer-sdk';
    script.type = 'text/javascript';
    script.src = '//g.alicdn.com/de/prismplayer/2.8.2/hls/aliplayer-vod-anti-min.js';
    document.body.appendChild(script);
}
